import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';

export const getCompanyHubSpaceKeyForSSR = async () => {
	const { activationId, cloudId } = getPreloaderFnContext();

	if (activationId && cloudId) {
		return `~HUB-${cloudId}-${activationId}~`;
	}
};
